const FHIR_NAME_MAX = 255;

/**
 * FHIR's computer-friendly `name`, shaped to `[A-Z][A-Za-z0-9_]{0,254}`.
 * Derived from the human name, not the url: app-minted urls end in a UUID,
 * which would make every token meaningless. Nothing resolves by it — the url
 * is the identity — so it is free to change when the name is corrected.
 */
export function machineName(name: string): string {
  const token = name
    .split(/[^A-Za-z0-9]+/)
    .filter(Boolean)
    .map((word) => word[0]?.toUpperCase() + word.slice(1))
    .join("");
  const leading = /^[A-Z]/.test(token) ? token : `N${token}`;
  return leading.slice(0, FHIR_NAME_MAX);
}

/** The domain's one human name, split the way FHIR wants it: `title` for people, `name` for machines. */
export function catalogNameToFhir(name: string): { title: string; name: string } {
  return { title: name, name: machineName(name) };
}
